var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGoogleCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-bbox": "64 161 403.01 229.01",
    viewBox: "0 0 512 512",
    xmlns: "http://www.w3.org/2000/svg",
    "data-type": "color",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M318.84 388.5c-6.85 0-13.06-3.78-16.2-9.87l-17.67-34.19c-3.72-7.19-10.77-11.49-18.87-11.49-8.02 0-15.27 4.44-18.92 11.58l-17.38 34.02a18.164 18.164 0 0 1-16.24 9.94H97.74c-17.78 0-32.24-14.46-32.24-32.24V194.74c0-17.78 14.46-32.24 32.24-32.24h335.52c17.78 0 32.24 14.46 32.24 32.24v161.52c0 17.78-14.46 32.24-32.24 32.24H318.84z",
    fill: "#ff0000",
    "data-color": 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.26 164c16.95 0 30.74 13.79 30.74 30.74v161.52c0 16.95-13.79 30.74-30.74 30.74H318.84c-6.29 0-11.99-3.47-14.87-9.05l-17.67-34.19a22.649 22.649 0 0 0-20.2-12.3c-8.59 0-16.35 4.75-20.25 12.4l-17.38 34.02a16.67 16.67 0 0 1-14.91 9.12H97.74C80.79 387 67 373.21 67 356.26V194.74C67 177.79 80.79 164 97.74 164h335.52m0-3H97.74C79.11 161 64 176.11 64 194.74v161.52C64 374.89 79.11 390 97.74 390h115.82c7.42 0 14.21-4.16 17.58-10.76l17.38-34.02c3.66-7.17 10.62-10.76 17.58-10.76 6.93 0 13.86 3.56 17.54 10.68l17.67 34.19a19.736 19.736 0 0 0 17.54 10.68h114.42c18.63 0 33.74-15.11 33.74-33.74V194.74C467 176.11 451.89 161 433.26 161z",
    fill: "#ffffff",
    "data-color": 2
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M200.5 275.5c0 25.957-21.043 47-47 47s-47-21.043-47-47 21.043-47 47-47 47 21.043 47 47z",
    "data-color": 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.5 230c25.09 0 45.5 20.41 45.5 45.5S178.59 321 153.5 321 108 300.59 108 275.5s20.41-45.5 45.5-45.5m0-3c-26.79 0-48.5 21.71-48.5 48.5s21.71 48.5 48.5 48.5 48.5-21.71 48.5-48.5-21.71-48.5-48.5-48.5z",
    fill: "#ff0000",
    "data-color": 1
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M422.5 275.5c0 25.957-21.043 47-47 47s-47-21.043-47-47 21.043-47 47-47 47 21.043 47 47z",
    "data-color": 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.5 230c25.09 0 45.5 20.41 45.5 45.5S400.59 321 375.5 321 330 300.59 330 275.5s20.41-45.5 45.5-45.5m0-3c-26.79 0-48.5 21.71-48.5 48.5s21.71 48.5 48.5 48.5 48.5-21.71 48.5-48.5-21.71-48.5-48.5-48.5z",
    fill: "#ff0000",
    "data-color": 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleCard);
export default __webpack_public_path__ + "static/media/googleCard.880bced441762856b363e5129d0699e2.svg";
export { ForwardRef as ReactComponent };